import { Component } from "@angular/core";

@Component({
  templateUrl: "./account-view.component.html",
})
export class AccountViewComponent {}
